import { render, staticRenderFns } from "./MyTicketsCustom.vue?vue&type=template&id=23e662ea&"
import script from "./MyTicketsCustom.vue?vue&type=script&lang=js&"
export * from "./MyTicketsCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports